import { QSetGenerateResult } from '@exam-management/qset-generate-result';
import { Flex } from '@shared/components';

export default function QSetGeneratorResultsPage() {
  return (
    <Flex
      sx={{ flexDirection: 'column', p: (theme) => theme.spacing(6), flex: 1, height: '100dvh' }}
    >
      <QSetGenerateResult />
    </Flex>
  );
}
